"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../hooks");
var _CetComponentsProvider = require("../../../../../providers/CetComponentsProvider");
const useStyles = props => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const ccAudiencePickerGroupsAndClassesSelectionStyle = (0, _react.useMemo)(() => {
    const deviceProps = () => {
      if (!isMobileView) {
        return {
          border: `1px solid ${themeColors?.general.border}`,
          borderRadius: `${pxToRem(7)} ${pxToRem(7)} 0 0`,
          padding: `${pxToRem(7)} ${pxToRem(10)} 0`
        };
      }
      return {};
    };
    const headerDeviceProps = () => {
      if (isMobileView) {
        return {
          borderBottom: `1px solid ${themeColors?.general.border}`
        };
      }
      return {};
    };
    const ccAudiencePickerGroupsAndClassesSelection = (0, _css.css)({
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    });
    const ccAudiencePickerGroupsAndClassesSelectionList = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1',
      overflow: 'hidden',
      ...deviceProps()
    });
    const ccAudiencePickerGroupsAndClassesSelectionListHeader = (0, _css.css)({
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: pxToRem(16),
      ...headerDeviceProps()
    });
    const ccAudiencePickerGroupsAndClassesSelectionListHeaderTabs = (0, _css.css)({
      position: 'relative'
    });
    const ccAudiencePickerGroupsAndClassesSelectionListHeaderButtons = (0, _css.css)({
      display: 'flex',
      gap: pxToRem(10)
    });
    return {
      ccAudiencePickerGroupsAndClassesSelection,
      ccAudiencePickerGroupsAndClassesSelectionList,
      ccAudiencePickerGroupsAndClassesSelectionListHeader,
      ccAudiencePickerGroupsAndClassesSelectionListHeaderTabs,
      ccAudiencePickerGroupsAndClassesSelectionListHeaderButtons
    };
  }, [isMobileView, pxToRem, themeColors?.general.border]);
  return {
    'cc-AudiencePicker__groups-and-classes-selection': ccAudiencePickerGroupsAndClassesSelectionStyle.ccAudiencePickerGroupsAndClassesSelection,
    'cc-AudiencePicker__groups-and-classes-selection__list': ccAudiencePickerGroupsAndClassesSelectionStyle.ccAudiencePickerGroupsAndClassesSelectionList,
    'cc-AudiencePicker__groups-and-classes-selection__list-header': ccAudiencePickerGroupsAndClassesSelectionStyle.ccAudiencePickerGroupsAndClassesSelectionListHeader,
    'cc-AudiencePicker__groups-and-classes-selection__list-header__tabs': ccAudiencePickerGroupsAndClassesSelectionStyle.ccAudiencePickerGroupsAndClassesSelectionListHeaderTabs,
    'cc-AudiencePicker__groups-and-classes-selection__list-header__buttons': ccAudiencePickerGroupsAndClassesSelectionStyle.ccAudiencePickerGroupsAndClassesSelectionListHeaderButtons
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;